import TipTapTable from '@tiptap/extension-table'
import * as h from '#editors/html'
import * as a from '#editors/html/attribute'

export const Table = TipTapTable.extend({
  addAttributes() {
    return {
      index: {
        default: -1,
        parseHTML: element => element.getAttribute('data-index'),
        renderHTML: attributes => ({ ['data-index']: attributes.index }),
      },
    }
  },
  addNodeView() {
    return props => {
      const index = a.attribute('data-index', props.node.attrs.index)
      const contentDOM = h.tbody([], [])
      // prettier-ignore
      const dom =
        h.div([a.class_('table-responsive')], [
          h.table([index], [contentDOM])
        ])
      return { dom, contentDOM }
    }
  },
})
